<template>
  <div class="component-footer footer">
    <div class="footer-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.footer {
  margin: auto toRem(-24) 0;
}

.footer-content {
  width: 100%;
  display: flex;
  max-width: toRem(924);
  margin: 0 auto;
}
</style>
